<ng-template #template><ng-content></ng-content></ng-template>

<ng-container *ngIf="!fullscreen && show" [ngTemplateOutlet]="template"></ng-container>
<div *ngIf="!fullscreen && show && backdrop" class="loading-backdrop {{ backdropClass }}"></div>
